import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../Services/Auth/auth.service';
import { BackendAccessService } from '../../../Services/APICalls/backend-access-service';
import { CanActivateService } from '../../../Services/CanActivate/can-activate.service';
import { UserProfileData } from '../../../interfaces/user-profile-data';
import { Subject, Subscription, of, switchMap, takeUntil } from 'rxjs';
import { BranchSelectionService } from '../../../Services/branch-selection.service';

@Component({
    selector: 'app-branch-inputs',
    templateUrl: './branch-inputs.component.html',
    styleUrls: ['./branch-inputs.component.scss'],
    standalone: false
})
export class BranchInputsComponent implements OnInit {
  @Input() isSidebarExtended: boolean = false;
  authService: AuthService;
  Header!: object;
  hideMatBadge!: boolean;
  badgeCounter!: number;
  isViewed!: boolean;
  isUserTiedToCompany!: boolean;
  userRoles: string[] = [];
  selectedBranch!: string | null;
  @Input() branches: any[] = [];
  @Input() companyProfile: any;
  private unsubscribe$ = new Subject<void>();
  selectedBranchSubscription: Subscription | undefined;
  selectedBranchId!: string | null;
  singleBranchInfo!: any;
  selectedProduct: string | null = null;

  constructor(
    public auth: AuthService,

    public canActivate: CanActivateService,
    public backend: BackendAccessService,

    public branchSelectionService: BranchSelectionService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.authService = auth;
  }

  /* istanbul ignore next */

  //potentially
  ngOnInit(): void {
    this.authService.getUserProfile$().subscribe((results: UserProfileData) => {
      if (results && 'http://allegion.com/claims/roles' in results) {
        this.userRoles = results['http://allegion.com/claims/roles'];
        this.isUserTiedToCompany = this.userRoles.length > 0;
      } else {
        this.userRoles = [];
        this.isUserTiedToCompany = false;
      }
    });

    // Fetch branches
    this.canActivate.branchAssignmentsDetails$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((branchAssignments) => {
        this.branches = branchAssignments;
        this.branchSelectionService.branchesLoaded.emit(branchAssignments);

        // Automatically select the branch if there's only one
        if (this.branches.length === 1) {
          this.selectedBranch = this.branches[0].branchId;
          this.singleBranchInfo = this.branches[0];
          // Update the selection in the service
          this.branchSelectionService.setSelectedBranch(this.selectedBranch!);
        }

        this.changeDetector.detectChanges();
      });

    // Subscribe to the companyName$ observable
    this.branchSelectionService.companyName$.subscribe((name) => {
      this.companyProfile = { ...this.companyProfile, companyName: name };
      this.changeDetector.detectChanges();
    });

    this.branchSelectionService.selectedBranch$
      .pipe(
        takeUntil(this.unsubscribe$),
        switchMap((selectedBranchId) => {
          if (selectedBranchId) {
            return this.backend.getBranchDetailsByCompanyAccountId(
              selectedBranchId
            );
          } else {
            return of(null);
          }
        })
      )
      .subscribe((response) => {
        if (response && response.length > 0) {
          this.singleBranchInfo = response[0];
          // Ensure the dropdown reflects the correct branch
          this.selectedBranch = this.singleBranchInfo
            ? this.singleBranchInfo.branchId
            : null;
        } else {
          this.singleBranchInfo = null;
        }
        console.log('singleBranchInfo:', this.singleBranchInfo);
        this.changeDetector.detectChanges();
      });
  }

  ngAfterViewInit(): void {
    this.branchSelectionService.selectedBranch$.subscribe((branch) => {
      this.selectedBranchId = branch;
      this.changeDetector.detectChanges();
    });
  }

  ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }

  onBranchChanged(newBranch: string) {
    this.branchSelectionService.setSelectedBranch(newBranch);
    this.branchSelectionService.branchSelected.emit({
      selectedBranch: newBranch,
      branches: this.branches,
    });
  }

  doLogout() {
    console.log('Logging out...');
    this.authService.logout();
  }
  /* istanbul ignore next */
  goToResource() {
    location.href = environment.resourceLink;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
